export function mapCertificateExpiration(translateFn: Function) {
  return {
    [CERTIFICATE_STATUS.NOT_SOON_TO_EXPIRE]: { label: translateFn('No action needed'), color: '#005850' },
    [CERTIFICATE_STATUS.SOON_TO_EXPIRE]: { label: translateFn('Expires soon'), color: '#FFB74D' },
    [CERTIFICATE_STATUS.EXPIRED]: { label: translateFn('Expired'), color: '#D23138' },
  };
}

enum CERTIFICATE_STATUS {
  NOT_SOON_TO_EXPIRE = 0,
  SOON_TO_EXPIRE = 1,
  EXPIRED = 2,
}

export enum EasmCertificateExpirationEvents {
  LEGEND_CLICK = 'easm-certificate-expiration-legend-click',
}
